// extracted by mini-css-extract-plugin
export var BtnV2 = "Footer-module--BtnV2--75b41";
export var BtnV2Black = "Footer-module--BtnV2--black--7a7ff";
export var BtnV2Borderless = "Footer-module--BtnV2--borderless--80c13";
export var BtnV2Cloud = "Footer-module--BtnV2--cloud--3d684";
export var BtnV2Disabled = "Footer-module--BtnV2--disabled--88c09";
export var BtnV2Focusable = "Footer-module--BtnV2--focusable--90c1e";
export var BtnV2Fullwidth = "Footer-module--BtnV2--fullwidth--09114";
export var BtnV2Gold = "Footer-module--BtnV2--gold--468c9";
export var BtnV2Grey = "Footer-module--BtnV2--grey--849ad";
export var BtnV2Icon = "Footer-module--BtnV2--icon--cdda8";
export var BtnV2Lg = "Footer-module--BtnV2--lg--04936";
export var BtnV2Midnight = "Footer-module--BtnV2--midnight--1729d";
export var BtnV2Multiline = "Footer-module--BtnV2--multiline--ed742";
export var BtnV2Nofocus = "Footer-module--BtnV2--nofocus--8f057";
export var BtnV2Secondary = "Footer-module--BtnV2--secondary--6e173";
export var BtnV2Sm = "Footer-module--BtnV2--sm--bb4c1";
export var BtnV2Solid = "Footer-module--BtnV2--solid--c87e3";
export var BtnV2Square = "Footer-module--BtnV2--square--40e24";
export var BtnV2Success = "Footer-module--BtnV2--success--eab57";
export var BtnV2Text = "Footer-module--BtnV2--text--c81b3";
export var BtnV2Warning = "Footer-module--BtnV2--warning--7cc99";
export var BtnV2White = "Footer-module--BtnV2--white--19bd6";
export var BtnV2Xl = "Footer-module--BtnV2--xl--ac9b1";
export var BtnV2Yellow = "Footer-module--BtnV2--yellow--bcfd4";
export var ColorBlock = "Footer-module--ColorBlock--acaa5";
export var ColorBlockColorGrey = "Footer-module--ColorBlock--colorGrey--a394e";
export var ColorBlockGrey = "Footer-module--ColorBlock--grey--07630";
export var ColorBlockMidGrey = "Footer-module--ColorBlock--midGrey--8581c";
export var ColorBlockPink = "Footer-module--ColorBlock--pink--c3127";
export var ColorBlockPrimary = "Footer-module--ColorBlock--primary--7607f";
export var ColorBlockPrimaryDark = "Footer-module--ColorBlock--primaryDark--ea1bf";
export var ColorBlockPrimaryLight = "Footer-module--ColorBlock--primaryLight--b3403";
export var ColorBlockPrimaryMid = "Footer-module--ColorBlock--primaryMid--ad1d1";
export var ColorBlockPurple = "Footer-module--ColorBlock--purple--b1a10";
export var ColorBlockRed = "Footer-module--ColorBlock--red--c6f8d";
export var ColorBlockSecondary = "Footer-module--ColorBlock--secondary--3f962";
export var ColorBlockSecondaryDark = "Footer-module--ColorBlock--secondaryDark--c2333";
export var ColorBlockSecondaryLight = "Footer-module--ColorBlock--secondaryLight--04575";
export var ColorBlockSecondaryMid = "Footer-module--ColorBlock--secondaryMid--1391b";
export var ColorBlockText = "Footer-module--ColorBlock--text--d2196";
export var ColorBlockYellow = "Footer-module--ColorBlock--yellow--d12bf";
export var ColorBlocks = "Footer-module--ColorBlocks--ac030";
export var DashboardTopoptions = "Footer-module--Dashboard--topoptions--56e10";
export var HideEmbedded = "Footer-module--HideEmbedded--ac486";
export var ShowEmbedded = "Footer-module--ShowEmbedded--1621f";
export var Template__descriptionContent = "Footer-module--Template__description-content--cc80d";
export var __active = "Footer-module--__active--00dc1";
export var __custom = "Footer-module--__custom--08478";
export var _pin = "Footer-module--_pin--83b4a";
export var _pinText = "Footer-module--_pinText--99db3";
export var aliceCarousel__dots = "Footer-module--alice-carousel__dots--fdda0";
export var aliceCarousel__dotsItem = "Footer-module--alice-carousel__dots-item--1a02d";
export var blogLink = "Footer-module--blogLink--2432f";
export var btnGroup = "Footer-module--btn-group--e0757";
export var ccCompliance = "Footer-module--cc-compliance--51706";
export var column = "Footer-module--column--f79ef";
export var h1 = "Footer-module--h1--ca732";
export var h2 = "Footer-module--h2--44c96";
export var h3 = "Footer-module--h3--429ed";
export var h4 = "Footer-module--h4--aeb55";
export var legal = "Footer-module--legal--094a2";
export var link = "Footer-module--link--ea341";
export var maxWidth = "Footer-module--max-width--155b3";
export var menuOpen = "Footer-module--menu-open--e9f05";
export var noChildPMb = "Footer-module--no-child-p-mb--28e2c";
export var nobar = "Footer-module--nobar--8cfc4";
export var pin = "Footer-module--pin--3d815";
export var seogroup = "Footer-module--seogroup--c8c6c";
export var wrapper = "Footer-module--wrapper--74552";